import React, { useState } from 'react';
import './ChoiceCards.css';

const svg = (paths) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths}</svg>
);
export const CHOICE_ICON = {
  shield: svg(<><path d="M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6z" /><path d="M9 12l2 2 4-4" /></>),
  gear: svg(<><path d="M4 7h9M17 7h3M4 17h3M11 17h9" /><circle cx="15" cy="7" r="2" /><circle cx="9" cy="17" r="2" /></>),
  doc: svg(<><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4M10 12h5M10 16h5" /></>),
  eye: svg(<><path d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6z" /><circle cx="12" cy="12" r="2.5" /></>),
};

// A choice made of cards: an icon, a title (with an optional small tag), one line saying what it is, and optional bullet points.
// options: [{ key, icon, title, tag, text, points }]. Used for "Rapporttype" and "Til hvem" on Rapporter.
export default function ChoiceCards({ options, value, onChange, label }) {
  // Only the line of text shows at first. Pressing the card that is already chosen opens (or closes) its points; pressing the
  // other card chooses it and folds everything, so the points never follow along from one choice to the next.
  const [open, setOpen] = useState(() => new Set());
  const press = (o) => {
    if (value === o.key) { if (o.points) setOpen((prev) => (prev.has(o.key) ? new Set() : new Set([o.key]))); return; }
    setOpen(new Set());
    onChange(o.key);
  };
  return (
    <div className="cc" role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <button type="button" key={o.key} role="radio" aria-checked={value === o.key} className={`cc__o${value === o.key ? ' is-on' : ''}`} onClick={() => press(o)}>
          <span className="cc__i">{CHOICE_ICON[o.icon]}</span>
          <span className="cc__t">
            <b>{o.title}{o.tag && <em>{o.tag}</em>}</b>
            <span>{o.text}</span>
            {o.points && open.has(o.key) && <ul>{o.points.map((p) => <li key={p}>{p}</li>)}</ul>}
          </span>
          {o.points && <svg className={`cc__ch${open.has(o.key) ? ' is-open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>}
        </button>
      ))}
    </div>
  );
}
